import { css } from '@vers/styled-system/css';

export const errorList = css({
  marginBottom: '2',
});

export const errorItem = css({
  color: 'red.500',
  fontSize: 'sm',
});
